import { Button } from '../styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { IconSvg } from '@/components/feature/UserPermissionPage/TabPermissionManagement/styles'
import { EditClaimButtonHook } from './EditClaimButton.hook'

function EditClaimButton() {
  const { redirectToHealthClaimDetailPage, isEditable } = EditClaimButtonHook()
  return (
    isEditable && (
      <Button onClick={redirectToHealthClaimDetailPage}>
        <IconSvg src={IMAGE_URL.editIcon} /> แก้ไข
      </Button>
    )
  )
}

export default EditClaimButton
